<style src="./EmployeePerformance.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content EmployeePerformance">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="filterReport">
        <div class="formContainer">
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="startDate"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="mail-box">
      <table class="table table-hover table-mail reportlist">
        <thead>
          <th>Monitor</th>
          <th
            title="Quantidade de lançamentos feito pelo Monitor na data pesquisada. Esses lançamentos podem ou não ter sido pago"
          >
            Lançamentos
            <i
              class="fa fa-arrow-down"
              :class="{ selected: orderField === 'registered' }"
              @click="selectOrder('registered')"
            ></i>
          </th>
          <th
            title="Quantidade de pagamentos realizado pelo Monitor na data da pesquisa. O lançamento do ticket pode não necessariamente ter sido feito no dia da data da pesquisa"
          >
            Pagamentos
            <i
              class="fa fa-arrow-down"
              :class="{ selected: orderField === 'sold' }"
              @click="selectOrder('sold')"
            ></i>
          </th>
          <th
            title="Quantidade de tickets lançados e não pagos na data da pesquisa. Mesmo se o ticket tiver sido pago em outra data, contará como Não Pago."
          >
            Não Pagos
            <i
              class="fa fa-arrow-down"
              :class="{ selected: orderField === 'notPaid' }"
              @click="selectOrder('notPaid')"
            ></i>
          </th>
          <th>
            Isentos
            <i
              class="fa fa-arrow-down"
              :class="{ selected: orderField === 'exempt' }"
              @click="selectOrder('exempt')"
            ></i>
          </th>
          <th>
            Idosos
            <i
              class="fa fa-arrow-down"
              :class="{ selected: orderField === 'aged' }"
              @click="selectOrder('aged')"
            ></i>
          </th>
          <th>
            Estornos
            <i
              class="fa fa-arrow-down"
              :class="{ selected: orderField === 'reversed' }"
              @click="selectOrder('reversed')"
            ></i>
          </th>
          <th
            title="Quantidade de tickets registrados na data da pesquisa somado a quantidade de tickets registrado em datas anteriores mas pagos na data da pesquisa."
          >
            Total Negociados
            <i
              class="fa fa-arrow-down"
              :class="{ selected: orderField === 'totalNegotiated' }"
              @click="selectOrder('totalNegotiated')"
            ></i>
          </th>
        </thead>

        <tbody>
          <tr class="read" v-for="(item, idx) in orderedList" :key="idx">
            <td>{{ item.employeeName }}</td>
            <td>{{ item.registered | numberBR }}</td>
            <td>{{ item.sold | numberBR }}</td>
            <td>{{ item.notPaid | numberBR }}</td>
            <td>{{ item.exempt | numberBR }}</td>
            <td>{{ item.aged | numberBR }}</td>
            <td>{{ item.reversed | numberBR }}</td>
            <td>{{ item.totalNegotiated | numberBR }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';
import moment from 'moment';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      startDate: '2019-10-30',
      endDate: '2019-10-31',
      resultList: [],
      orderField: 'totalNegotiated',
    };
  },
  filters: {
    numberBR(value) {
      if (!value) {
        return '-';
      }
      // return (value / 100).toFixed(2).toString().replace('.', ',');
      return value.toLocaleString('pt-BR');
    },
  },
  mounted() {
    this.setInitialSateTime();
  },
  computed: {
    orderedList() {
      return Array.from(this.resultList).sort((a, b) =>
        a[this.orderField] > b[this.orderField] ? -1 : 1,
      );
    },
  },
  methods: {
    selectOrder(orderField) {
      this.orderField = orderField;
    },
    setInitialSateTime() {
      const today = new Date();
      this.startDate = moment(today).format('YYYY-MM-DD');
      this.endDate = moment(today).format('YYYY-MM-DD');
    },
    async filterReport() {
      this.showSpinner = true;
      const query = {};
      this.resultList = [];
      if (this.startDate) {
        const startDate = new Date(`${this.startDate}T01:00:00Z`);
        const endDate = new Date(`${this.startDate}T22:00:00Z`);

        query.startDate = startDate;
        query.endDate = endDate;
      }

      try {
        const reports = await this.$store.dispatch(
          'REPORTS/EmployeePerformance',
          {
            query,
          },
        );

        this.resultList = reports;
        this.showSpinner = false;
      } catch (errors) {
        console.error(errors);

        this.resultList = [];
        this.showSpinner = false;
      }
    },
  },
};
</script>
